import { createSelector } from 'reselect';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

const _getAllLsBets = getBetSlip('allLsBets');
// @Todo need to update or discus
const getAllLsBets = createSelector([_getAllLsBets], allLsBets =>
  !SpringConfigs.MOCKED_DATA ? allLsBets : []
);

const getAllBets = getBetSlip('allLsBets');
const getSubscriptions = getBetSlip('subscriptions');
const getIsBetInProgress = getBetSlip('isBetInProgress');
const getBettedTrigger = getBetSlip('bettedTrigger');
const getUpdatedBetTickets = getBetSlip('updatedBetTickets');
const getBetTypesConf = getBetSlip('betTypesConf');
const getSelectedBetType = getBetSlip('selectedBetType');
const getSubscribedEvents = getBetSlip('subscribedEvents');
const getConflictingGameIds = getBetSlip('conflictingGameIds');
const getTicketsChanged = getBetSlip('ticketsChanged');
const getShouldAddCyprusCompetitions = getBetSlip(
  'shouldAddCyprusCompetitions'
);

const getEventIds = createSelector([getSubscriptions], subscriptions =>
  subscriptions.map(subscription => subscription.eventId)
);

const getIsSpEvents = createSelector([getAllBets], bets =>
  bets.some(({ sp }) => sp)
);

const getSingleBetById = (eventId?: string | number) =>
  createSelector([getAllBets], bets =>
    bets.find(bet => (eventId ? eventId === bet.eventId : false))
  );

const getAllBetIds = createSelector([getAllBets], bets =>
  bets.map(({ eventId }) => eventId)
);

const getAllBetsCount = createSelector([getAllBets], bets => bets.length);

export {
  getAllBets,
  getEventIds,
  getAllBetIds,
  getAllLsBets,
  getIsSpEvents,
  getAllBetsCount,
  getBetTypesConf,
  getBettedTrigger,
  getSingleBetById,
  getSubscriptions,
  getTicketsChanged,
  getIsBetInProgress,
  getSelectedBetType,
  getSubscribedEvents,
  getUpdatedBetTickets,
  getConflictingGameIds,
  getShouldAddCyprusCompetitions
};
